<template>
    <div class="animated fadeIn">
        <b-card>
            <h5><i class="fa fa-fw fa-ticket mr-2" />Tiket</h5>
            <hr />
            <b-row>
                <b-col md="9">
                    <b-button class="mr-2 font-weight-bold" variant="warning">{{ counts.open }} OPEN</b-button>
                    <b-button class="mr-2 font-weight-bold" variant="dark">{{ counts.ongoing }} ONGOING</b-button>
                    <b-button class="mr-2 font-weight-bold" variant="primary">{{ counts.done }} DONE</b-button>
                    <b-button class="mr-2 font-weight-bold" variant="success">{{ counts.closed }} CLOSED</b-button>
                    <b-button variant="primary" @click="getCounts">
                        <i class="fa fa-refresh" />
                    </b-button>
                </b-col>
                <b-col v-if="isAllowedForCreation()" md="3" class="text-right">
                    <b-link :to="`${$route.path}/create`">
                        <b-button variant="primary">
                            <i class="fa fa-plus mr-2" />Tiket Baru
                        </b-button>
                    </b-link>
                </b-col>
            </b-row>
            <div class="d-flex align-items-center justify-content-between my-3">
                <div class="mr-2">Filter</div>
                <b-form-input class="mr-2"
                    v-model="filter.no"
                    type="search"
                    placeholder="Nomor Tiket"
                    @keyup.enter="getItems"
                />
                <b-form-input class="mr-2"
                    v-model="filter.sn"
                    type="search"
                    placeholder="SN Engine"
                    @keyup.enter="getItems"
                />
                <b-form-select v-model="filter.status" :options="optStatus" class="mr-2">
                    <template v-slot:first>
                        <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                        <b-form-select-option value=-1>Semua</b-form-select-option>
                    </template>
                </b-form-select>
                <b-button variant="primary" @click="getItems">
                    <i class="fa fa-search" />
                </b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada tiket.
                </template>
                <template v-slot:cell(engine)="row">
                    {{ row.item.engine }}
                    <div class="small text-muted">{{ row.item.tipe }}</div>
                </template>
                <template v-slot:cell(lokasi)="row">
                    {{ row.item.lokasi }}
                    <div class="small text-muted">{{ row.item.wilayah }}</div>
                </template>
                <template v-slot:cell(open)="row">
                    {{ row.item.createdBy }}
                    <div class="small text-muted">{{ $helper.parseDate(row.item.createdAt) }} - {{ $helper.parseHourMinute(row.item.createdAt) }}</div>
                </template>
                <template v-slot:cell(close)="row">
                    {{ row.item.closedBy || '-' }}
                    <div v-if="row.item.closedAt != null" class="small text-muted">{{ $helper.parseDate(row.item.closedAt) }} - {{ $helper.parseHourMinute(row.item.closedAt) }}</div>
                    <div v-else class="small text-muted">-</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseBadgeVariantTipe(row.item.status.id)">
                        {{ row.item.status.name }}
                    </b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-link :to="`${$route.path}/${row.item.no}`">
                        <b-button size="sm" variant="primary">
                            <i class="fa fa-info" />
                        </b-button>
                    </b-link>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
    </div>
</template>

<script>

export default {
    name: 'tiket-main',
    data() {
        return {

            roleId: 1,

            initStatus: 0,
            isBusy: false,

            counts: {
                open: "...",
                ongoing: "...",
                done: "...",
                closed: "..."
            },

            filter: {
                no: "",
                sn: "",
                status: -1
            },

            optStatus: [
                { value: 1, text: "OPEN" },
                { value: 2, text: "ONGOING" },
                { value: 3, text: "DONE" },
                { value: 4, text: "CLOSED" },
                { value: 0, text: "BATAL" }
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "Nomor Tiket" },
                { key: "engine", label: "Engine" },
                { key: "lokasi", label: "Lokasi" },
                { key: "open", label: "Open Tiket" },
                { key: "close", label: "Close Tiket" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],

            items: [],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0

        }
    },
    methods: {

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            if(!this.$helper.isBlank(this.filter.no)) {
                param += "&filterNo=" + this.filter.no
            }

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSN=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            this.$axios.get("tiket/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        getCounts() {

            this.counts.open = "..."
            this.counts.ongoing = "..."
            this.counts.done = "..."
            this.counts.closed = "..."

            this.$axios.get("tiket/count").then(res => {

                let data = res.data
                this.counts.open = data.find(it => it.status == 1).count
                this.counts.ongoing = data.find(it => it.status == 2).count
                this.counts.done = data.find(it => it.status == 3).count
                this.counts.closed = data.find(it => it.status == 4).count

            })
            .catch(error => { this.$helper.parseError(this, error) })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        parseBadgeVariantTipe(id) {
            switch(id) {
                case 0: return "danger"
                case 1: return "warning"
                case 2: return "dark"
                case 3: return "primary"
                case 4: return "success"
                default: return "light"
            }
        },

        isAllowedForCreation() {
            return this.roleId == 0 || this.roleId == 2
        }

    },
    created() {

        this.roleId = Number(localStorage.getItem("roleId"))

        let flash = this.$helper.getFlash()
        if(flash != null) {
            this.$helper.toastSuccess(this, flash)
        }

        this.getCounts()
        this.getItems()

    }
}

</script>
